import * as z from "zod/v4";

export const previewAIResponse = {
  name: "previewAIResponse" as const,
  input: z.object({
    messageId: z.string(),
    channelId: z.string(),
    teamId: z.string(),
    message: z.string(),
    messageTs: z.string(),
    slackUserId: z.string(),
    threadTs: z.string().optional(),
    // Used for adding context when AI asks a clarifying question
    // When provided, continues the existing triage thread instead of creating a new one
    existingTriageThreadId: z.string().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    previewText: z.string().optional(),
    triageThreadId: z.string().optional(),
    error: z.string().optional(),
  }),
};
